<form [formGroup]="formulario" class="">
    <div class="ps-form-relation-field-container">
        <div *ngIf="!dateField.multivalued">
            <p class="ps_formBuilder_noValidators">
                Nenhuma configuração disponível, o campo <b>{{dateField.label}}</b> não é multivalorado
            </p>
        </div>
        <div *ngIf="dateField.multivalued">
            <p class="ps_multivalue_title">
                Nesta tela é possível configurar a quantidade mínima e máxima de opções que o campo multivalorado pode receber.
            </p>
        </div>
        <div *ngIf="dateField.multivalued" class="ps-row" fxLayout="row">
            <div fxLayout="row" fxFlex="100" fxLayoutGap="30px">
                <div fxFlex="30">
                    <mat-form-field style="width: 100%" appearance="fill">
                        <mat-label>Mínimo de opções</mat-label>
                        <input min="0" matInput type="number" formControlName="min_multivalued_options"/>
                    </mat-form-field>
                </div>
                <div fxFlex="30">
                    <mat-form-field style="width: 100%" appearance="fill">
                        <mat-label>Máximo de opções</mat-label>
                        <input min="0" matInput type="number" formControlName="max_multivalued_options"/>
                    </mat-form-field>
                </div>
                <a class="ps-clear-button" mat-stroked-button (click)="f.min_multivalued_options.reset(null); f.max_multivalued_options.reset(null);">Limpar</a>
            </div>
        </div>
    </div>
</form>